import { create } from 'zustand';

import { LOCAL_STORAGE_KEYS } from '../utils/common/local-storage-keys';
import { createSelectors } from '../utils/zustand/createSelectors';

interface TokenState {
  /** 사용자 인증 토큰 */
  token: string | null;

  /** 토큰 설정 (localStorage 동기화) */
  setToken: (token: string | null) => void;
}

// 초기값을 localStorage에서 가져오기 (클라이언트 사이드에서만)
const getInitialToken = () => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
};

/**
 * 사용자 인증 토큰을 관리하는 Zustand store
 * - localStorage와 단순 문자열 형태로 동기화 (Recoil 호환)
 * - 로그인/로그아웃 시 토큰 관리
 */
const useTokenStoreBase = create<TokenState>((set) => ({
  token: getInitialToken(),
  setToken: (token: string | null) => {
    set({ token });

    // localStorage 동기화 (단순 문자열로 저장)
    if (typeof window !== 'undefined') {
      if (token) {
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, token);
      } else {
        window.localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
      }
    }
  },
}));

export const useTokenStore = createSelectors(useTokenStoreBase);
